export default "__VITE_PUBLIC_ASSET__ff6d8558__"